// Fixed dark palette — the same as the trade-hub phone app (trade-hub/client/style/theme.js),
// so both apps look alike. No light/dark toggle.
const theme = {
  background: '#0f1115',
  surface: '#171a20',
  border: '#2a2d34',
  text: '#e6e8eb',
  textSecondary: '#9aa0aa',
  primary: '#4a7dff',
  primaryHover: '#3a6ae0',
  errorBg: '#3a1f22',
  errorBorder: '#6b2b30',
  errorText: '#f2a3a8',
};

export default theme;
